import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const currentUser = this.auth.currentUserValue;

    // Not logged in
    if (!currentUser || !this.auth.isAuthenticated) {
      this.auth.clearSession();
      return this.router.createUrlTree(['/auth/login']);
    }

    // Roles this route allows, e.g. data: { roles: ['Admin'] }
    const allowed = ((route.data['roles'] as string[] | undefined) ?? []).map((r) =>
      String(r).toLowerCase(),
    );

    // No roles set on the route: any logged-in user may enter
    if (!allowed.length) return true;

    // The user's roles, whether the API gave an array or a single string
    const raw: unknown = (currentUser as any).roles;
    const userRoles = (Array.isArray(raw) ? raw : raw ? [raw] : []).map((r) =>
      String(r).toLowerCase(),
    );

    if (userRoles.some((r) => allowed.includes(r))) return true;

    // Logged in, but the role isn't allowed
    return this.router.createUrlTree(['/error/unauthorized']);
  }
}